import { useEffect, useState } from "react";
import { api, fmtDateTime } from "../../lib/api";
import { toast } from "sonner";
import { UserPlus, Loader2 } from "lucide-react";

export const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ email: "", password: "", name: "", role: "editor" });
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/auth/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/auth/users", form);
      toast.success("Utilisateur créé");
      setForm({ email: "", password: "", name: "", role: "editor" });
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-8">
      <div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--red)]">Équipe</div>
        <h1 className="font-display text-4xl mt-2">Rédacteurs</h1>
        <p className="text-sm text-neutral-600 mt-1">
          Créez de nouveaux comptes pour vos collaborateurs.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-8">
        <div className="bg-white border border-[var(--line)] rounded-md overflow-hidden">
          <div className="grid grid-cols-[1fr_120px_120px_170px] gap-3 px-5 py-3 text-[11px] uppercase tracking-widest text-neutral-500 border-b border-[var(--line)] bg-[var(--bg-cream)]">
            <div>Email · Nom</div>
            <div>Rôle</div>
            <div>ID</div>
            <div>Créé le</div>
          </div>
          {users.map((u) => (
            <div key={u.id} className="grid grid-cols-[1fr_120px_120px_170px] gap-3 px-5 py-3 items-center border-b border-[var(--line)] last:border-b-0 text-sm">
              <div className="min-w-0">
                <div className="text-neutral-900 truncate">{u.email}</div>
                <div className="text-xs text-neutral-500">{u.name}</div>
              </div>
              <div>
                <span className={`text-[10px] uppercase tracking-widest px-2 py-1 rounded-sm ${
                  u.role === "admin" ? "bg-[var(--red-soft)] text-[var(--red)]" : "bg-neutral-100 text-neutral-600"
                }`}>{u.role}</span>
              </div>
              <div className="text-xs text-neutral-400 font-mono">{u.id.slice(0, 8)}…</div>
              <div className="text-xs text-neutral-500">{fmtDateTime(u.created_at)}</div>
            </div>
          ))}
        </div>

        <form
          onSubmit={submit}
          className="bg-white border border-[var(--line)] rounded-md p-6 space-y-4 h-fit"
        >
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-[var(--red)]">
            <UserPlus className="h-3 w-3" /> Nouveau rédacteur
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1">Nom</label>
            <input
              data-testid="user-name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              required
              className="w-full px-3 py-2 border border-[var(--line-strong)] rounded focus:border-[var(--red)] outline-none"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1">Email</label>
            <input
              data-testid="user-email"
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
              className="w-full px-3 py-2 border border-[var(--line-strong)] rounded focus:border-[var(--red)] outline-none"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1">Mot de passe</label>
            <input
              data-testid="user-password"
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              minLength={6}
              required
              className="w-full px-3 py-2 border border-[var(--line-strong)] rounded focus:border-[var(--red)] outline-none"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-1">Rôle</label>
            <select
              data-testid="user-role"
              value={form.role}
              onChange={(e) => setForm({ ...form, role: e.target.value })}
              className="w-full px-3 py-2 border border-[var(--line-strong)] rounded focus:border-[var(--red)] outline-none"
            >
              <option value="editor">Rédacteur</option>
              <option value="admin">Administrateur</option>
            </select>
          </div>
          <button data-testid="user-submit" type="submit" disabled={saving} className="btn-red w-full justify-center">
            {saving && <Loader2 className="h-4 w-4 animate-spin" />}
            Créer le compte
          </button>
        </form>
      </div>
    </div>
  );
};
